// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════════════
   ISO 컴포넌트 — 3D 호스트 · 히어로 · 공정
   ══════════════════════════════════════════════════════════════════ */

/* ── 3D 호스트 ─────────────────────────────────────── */
.iso3d {
  position: relative;
  width: 100%;
  height: 100%;
  display: block;
}

.iso3d-host,
.iso3d-fallback {
  position: absolute;
  inset: 0;
}

/* 크로스페이드 — 캔버스는 서서히 나타나고, SVG 폴백은 그 아래에서 사라진다. */
.iso3d-host {
  opacity: 0;
  transition: opacity 0.7s ease;
}

.iso3d--on .iso3d-host {
  opacity: 1;
}

.iso3d-fallback {
  transition: opacity 0.5s ease 0.1s;
}

.iso3d-fallback.is-leaving {
  opacity: 0;
}

.iso3d canvas {
  display: block;
  width: 100%;
  height: 100%;
}

.iso3d-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8%;
}

.iso-svg {
  width: 100%;
  height: 100%;
  overflow: visible;
}

.iso-stage {
  position: relative;
  overflow: hidden;
  background: var(--sunk);
  border: 1px solid var(--line);
  border-radius: var(--r-3);
}

/* ── 히어로 ────────────────────────────────────────── */
.ih {
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid var(--line-2);
  background: linear-gradient(178deg, var(--surface) 0%, var(--surface-2) 55%, #e6ebf3 100%);
}

.ih-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.ih-bg .iso-grid-bg {
  opacity: 0.35;
  mask-image: radial-gradient(ellipse 70% 80% at 72% 55%, #000 20%, transparent 70%);
}

.ih-in {
  position: relative;
  padding-top: 56px;
  padding-bottom: 40px;
  display: grid;
  grid-template-columns: minmax(300px, 0.86fr) minmax(380px, 1.14fr);
  gap: 24px;
  align-items: center;
  min-height: 600px;
}

.ih-title {
  font-size: var(--t-h1);
  font-weight: 800;
  line-height: 1.02;
  letter-spacing: -0.035em;
  margin-top: 18px;
  color: var(--ink);
}

.ih-title em {
  font-style: normal;
  color: var(--brand);
  display: block;
}

.ih-lede {
  margin-top: 18px;
  max-width: 46ch;
  color: var(--ink-2);
  font-size: 15.5px;
  line-height: 1.65;
}

.ih-cta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 28px;
}

.ih-facts {
  display: grid;
  grid-template-columns: repeat(4, max-content);
  gap: 22px;
  margin: 36px 0 0;
}

.ih-facts div {
  margin: 0;
}

.ih-facts dt {
  font-family: var(--f-d);
  font-size: 24px;
  font-weight: 800;
  color: var(--ink);
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.ih-facts dt span {
  font-size: 13px;
  margin-left: 2px;
  color: var(--ink-3);
}

.ih-facts dd {
  margin: 5px 0 0;
  font-family: var(--f-m);
  font-size: 10.5px;
  color: var(--ink-3);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.ih-stage {
  position: relative;
  height: 540px;
}

.ih-canvas {
  position: absolute;
  inset: 0;
}

.ih-stage-ground {
  position: absolute;
  left: 8%;
  right: 8%;
  bottom: 6%;
  height: 22%;
  border-radius: 50%;
  background: radial-gradient(ellipse at center, rgba(12, 17, 24, 0.14), rgba(12, 17, 24, 0) 70%);
  pointer-events: none;
}

.ih-fallback {
  width: 100%;
  height: 100%;
}

.ih-hud {
  position: absolute;
  font-family: var(--f-m);
  font-size: 10.5px;
  line-height: 1.7;
  letter-spacing: 0.08em;
  color: var(--ink-3);
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid var(--line);
  border-radius: 6px;
  padding: 6px 10px;
  backdrop-filter: blur(6px);
  pointer-events: none;
  text-transform: uppercase;
  animation: fade 0.8s 0.5s ease both;
}

.ih-hud--tl { top: 18px; left: 6px; display: flex; align-items: center; gap: 8px; }
.ih-hud--tr { top: 18px; right: 6px; text-align: right; }
.ih-hud--bl { bottom: 18px; left: 6px; }

.ih-live {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--spark);
  box-shadow: 0 0 0 0 rgba(255, 107, 26, 0.5);
  animation: pulse 1.8s ease-out infinite;
}

@keyframes pulse {
  0% { box-shadow: 0 0 0 0 rgba(255, 107, 26, 0.55); }
  100% { box-shadow: 0 0 0 9px rgba(255, 107, 26, 0); }
}

@media (max-width: 1024px) {
  .ih-in {
    grid-template-columns: 1fr;
    padding-top: 28px;
    min-height: 0;
  }
  .ih-stage {
    height: 400px;
    order: -1;
  }
}

@media (max-width: 640px) {
  .ih-stage {
    height: 300px;
  }
  .ih-hud--bl {
    display: none;
  }
  .ih-facts {
    grid-template-columns: repeat(2, max-content);
    gap: 16px 28px;
  }
}

/* ── 공정 ──────────────────────────────────────────── */
.ip-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(300px, 0.75fr);
  gap: 24px;
  align-items: stretch;
}

.ip-stage {
  min-height: 440px;
  background:
    radial-gradient(ellipse 60% 40% at 50% 70%, rgba(12, 17, 24, 0.08), transparent 70%),
    var(--sunk);
}

.ip-stage .iso3d {
  position: absolute;
  inset: 0;
}

.ip-fallback {
  width: 70%;
  height: 70%;
}

.ip-cap {
  position: absolute;
  left: 18px;
  bottom: 16px;
  font-size: 11px;
  letter-spacing: 0.06em;
  color: var(--ink-3);
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid var(--line);
  border-radius: 6px;
  padding: 8px 12px;
  backdrop-filter: blur(6px);
  pointer-events: none;
  line-height: 1.6;
  text-transform: uppercase;
  max-width: calc(100% - 36px);
}

.ip-cap b {
  color: var(--ink);
  font-weight: 600;
}

.ip-cap-meta {
  display: block;
  color: var(--brand);
}

.ip-auto {
  position: absolute;
  right: 14px;
  top: 14px;
  height: 28px;
  padding: 0 10px;
  border-radius: var(--r-pill);
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid var(--line);
  font-family: var(--f-m);
  font-size: 10.5px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ink-3);
  display: inline-flex;
  align-items: center;
  gap: 5px;
  backdrop-filter: blur(6px);
}

.ip-auto.is-on {
  color: var(--brand);
  border-color: var(--brand-soft-2);
}

.ip-steps {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.ip-step {
  width: 100%;
  text-align: left;
  display: grid;
  grid-template-columns: 34px 1fr;
  gap: 12px;
  padding: 16px 18px 16px 16px;
  border-radius: var(--r-2);
  border: 1px solid var(--line);
  background: var(--surface);
  position: relative;
  overflow: hidden;
  transition: all var(--dur) var(--ease);
  color: inherit;
}

.ip-step:hover {
  border-color: var(--line-strong);
  transform: translateX(3px);
}

.ip-step.is-on {
  border-color: var(--brand);
  box-shadow: var(--sh-iso-brand);
  transform: translate(-2px, -2px);
}

.ip-step-n {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1em;
  color: var(--ink-3);
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: var(--surface-3);
  display: grid;
  place-items: center;
  transition: all var(--dur);
  flex: none;
}

.ip-step.is-on .ip-step-n,
.ip-step-n.is-on {
  background: var(--brand);
  color: #fff;
}

.ip-step.is-done .ip-step-n {
  background: var(--ok-soft);
  color: var(--ok);
}

.ip-step-body {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.ip-step-t {
  font-family: var(--f-d);
  font-size: 16.5px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ink);
}

.ip-step-d {
  font-size: 13px;
  color: var(--ink-3);
  line-height: 1.55;
  margin-top: 3px;
  display: none;
}

.ip-step.is-on .ip-step-d {
  display: block;
}

.ip-step-meta {
  font-size: 10.5px;
  letter-spacing: 0.06em;
  color: var(--brand);
  margin-top: 8px;
  display: none;
}

.ip-step.is-on .ip-step-meta {
  display: block;
}

.ip-step-bar {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 3px;
  width: 100%;
  background: var(--brand);
  transform-origin: left;
  animation: ipbar linear both;
}

@keyframes ipbar {
  from { transform: scaleX(0); }
  to { transform: scaleX(1); }
}

/* 모바일 전용 설명 카드 — 데스크톱에서는 숨긴다 */
.ip-detail {
  display: none;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-2);
  padding: 16px 18px;
}

.ip-detail-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.ip-detail-head b {
  font-family: var(--f-d);
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.ip-detail p {
  color: var(--ink-2);
  font-size: 14px;
  line-height: 1.6;
}

.ip-detail .btn-link {
  margin-top: 10px;
}

/* ── 태블릿 이하: 무대 → 4칸 스트립 → 설명 카드 ── */
@media (max-width: 960px) {
  .ip-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }
  .ip-stage {
    min-height: 380px;
  }
  .ip-steps {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 8px;
  }
  .ip-step {
    grid-template-columns: 1fr;
    gap: 8px;
    padding: 12px 8px 14px;
    text-align: center;
    justify-items: center;
    align-content: start;
    min-height: 100%;
  }
  .ip-step:hover {
    transform: none;
  }
  .ip-step.is-on {
    transform: none;
    box-shadow: 4px 4px 0 var(--brand-deep);
    background: var(--brand-soft);
  }
  .ip-step-n {
    width: 30px;
    height: 30px;
    font-size: 11px;
  }
  .ip-step-body {
    align-items: center;
  }
  .ip-step-t {
    font-size: 13px;
    line-height: 1.25;
  }
  .ip-step.is-on .ip-step-d,
  .ip-step.is-on .ip-step-meta {
    display: none;
  }
  .ip-detail {
    display: block;
  }
}

@media (max-width: 640px) {
  .ip-stage {
    min-height: 300px;
  }
  .ip-cap {
    left: 10px;
    bottom: 10px;
    padding: 6px 9px;
    font-size: 10px;
  }
  .ip-auto {
    right: 10px;
    top: 10px;
  }
  .ip-step {
    padding: 10px 4px 12px;
  }
  .ip-step-t {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/iso.css"],"names":[],"mappings":"AAAA;;uEAEuE;;AAEvE,sDAAsD;AACtD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;AACV;;AAEA,iDAAiD;AACjD;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,0FAA0F;AAC5F;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,aAAa;EAEL,kFAAkF;AAC5F;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,kEAAkE;EAClE,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,+FAA+F;EAC/F,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,qCAAqC;EACrC,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;EACpB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA,cAAc,SAAS,EAAE,SAAS,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAClF,cAAc,SAAS,EAAE,UAAU,EAAE,iBAAiB,EAAE;AACxD,cAAc,YAAY,EAAE,SAAS,EAAE;;AAEvC;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,2CAA2C;EAC3C,uCAAuC;AACzC;;AAEA;EACE,KAAK,4CAA4C,EAAE;EACnD,OAAO,2CAA2C,EAAE;AACtD;;AAEA;EACE;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,aAAa;EACf;EACA;IACE,aAAa;IACb,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,6CAA6C;IAC7C,cAAc;EAChB;AACF;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,8DAA8D;EAC9D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB;;eAEa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,qCAAqC;EACrC,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,4BAA4B;EAC5B,yBAAyB;EACzB,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;;EAEE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,OAAO,oBAAoB,EAAE;EAC7B,KAAK,oBAAoB,EAAE;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,0BAA0B;EAC1B,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,gDAAgD;IAChD,QAAQ;EACV;EACA;IACE,0BAA0B;IAC1B,QAAQ;IACR,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,uCAAuC;IACvC,6BAA6B;EAC/B;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,WAAW;IACX,SAAS;EACX;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ══════════════════════════════════════════════════════════════════\n   ISO 컴포넌트 — 3D 호스트 · 히어로 · 공정\n   ══════════════════════════════════════════════════════════════════ */\n\n/* ── 3D 호스트 ─────────────────────────────────────── */\n.iso3d {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.iso3d-host,\n.iso3d-fallback {\n  position: absolute;\n  inset: 0;\n}\n\n/* 크로스페이드 — 캔버스는 서서히 나타나고, SVG 폴백은 그 아래에서 사라진다. */\n.iso3d-host {\n  opacity: 0;\n  transition: opacity 0.7s ease;\n}\n\n.iso3d--on .iso3d-host {\n  opacity: 1;\n}\n\n.iso3d-fallback {\n  transition: opacity 0.5s ease 0.1s;\n}\n\n.iso3d-fallback.is-leaving {\n  opacity: 0;\n}\n\n.iso3d canvas {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.iso3d-fallback {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8%;\n}\n\n.iso-svg {\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n}\n\n.iso-stage {\n  position: relative;\n  overflow: hidden;\n  background: var(--sunk);\n  border: 1px solid var(--line);\n  border-radius: var(--r-3);\n}\n\n/* ── 히어로 ────────────────────────────────────────── */\n.ih {\n  position: relative;\n  overflow: hidden;\n  border-bottom: 1px solid var(--line-2);\n  background: linear-gradient(178deg, var(--surface) 0%, var(--surface-2) 55%, #e6ebf3 100%);\n}\n\n.ih-bg {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n.ih-bg .iso-grid-bg {\n  opacity: 0.35;\n  -webkit-mask-image: radial-gradient(ellipse 70% 80% at 72% 55%, #000 20%, transparent 70%);\n          mask-image: radial-gradient(ellipse 70% 80% at 72% 55%, #000 20%, transparent 70%);\n}\n\n.ih-in {\n  position: relative;\n  padding-top: 56px;\n  padding-bottom: 40px;\n  display: grid;\n  grid-template-columns: minmax(300px, 0.86fr) minmax(380px, 1.14fr);\n  gap: 24px;\n  align-items: center;\n  min-height: 600px;\n}\n\n.ih-title {\n  font-size: var(--t-h1);\n  font-weight: 800;\n  line-height: 1.02;\n  letter-spacing: -0.035em;\n  margin-top: 18px;\n  color: var(--ink);\n}\n\n.ih-title em {\n  font-style: normal;\n  color: var(--brand);\n  display: block;\n}\n\n.ih-lede {\n  margin-top: 18px;\n  max-width: 46ch;\n  color: var(--ink-2);\n  font-size: 15.5px;\n  line-height: 1.65;\n}\n\n.ih-cta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 28px;\n}\n\n.ih-facts {\n  display: grid;\n  grid-template-columns: repeat(4, max-content);\n  gap: 22px;\n  margin: 36px 0 0;\n}\n\n.ih-facts div {\n  margin: 0;\n}\n\n.ih-facts dt {\n  font-family: var(--f-d);\n  font-size: 24px;\n  font-weight: 800;\n  color: var(--ink);\n  letter-spacing: -0.02em;\n  font-variant-numeric: tabular-nums;\n  line-height: 1;\n}\n\n.ih-facts dt span {\n  font-size: 13px;\n  margin-left: 2px;\n  color: var(--ink-3);\n}\n\n.ih-facts dd {\n  margin: 5px 0 0;\n  font-family: var(--f-m);\n  font-size: 10.5px;\n  color: var(--ink-3);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.ih-stage {\n  position: relative;\n  height: 540px;\n}\n\n.ih-canvas {\n  position: absolute;\n  inset: 0;\n}\n\n.ih-stage-ground {\n  position: absolute;\n  left: 8%;\n  right: 8%;\n  bottom: 6%;\n  height: 22%;\n  border-radius: 50%;\n  background: radial-gradient(ellipse at center, rgba(12, 17, 24, 0.14), rgba(12, 17, 24, 0) 70%);\n  pointer-events: none;\n}\n\n.ih-fallback {\n  width: 100%;\n  height: 100%;\n}\n\n.ih-hud {\n  position: absolute;\n  font-family: var(--f-m);\n  font-size: 10.5px;\n  line-height: 1.7;\n  letter-spacing: 0.08em;\n  color: var(--ink-3);\n  background: rgba(255, 255, 255, 0.72);\n  border: 1px solid var(--line);\n  border-radius: 6px;\n  padding: 6px 10px;\n  backdrop-filter: blur(6px);\n  pointer-events: none;\n  text-transform: uppercase;\n  animation: fade 0.8s 0.5s ease both;\n}\n\n.ih-hud--tl { top: 18px; left: 6px; display: flex; align-items: center; gap: 8px; }\n.ih-hud--tr { top: 18px; right: 6px; text-align: right; }\n.ih-hud--bl { bottom: 18px; left: 6px; }\n\n.ih-live {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--spark);\n  box-shadow: 0 0 0 0 rgba(255, 107, 26, 0.5);\n  animation: pulse 1.8s ease-out infinite;\n}\n\n@keyframes pulse {\n  0% { box-shadow: 0 0 0 0 rgba(255, 107, 26, 0.55); }\n  100% { box-shadow: 0 0 0 9px rgba(255, 107, 26, 0); }\n}\n\n@media (max-width: 1024px) {\n  .ih-in {\n    grid-template-columns: 1fr;\n    padding-top: 28px;\n    min-height: 0;\n  }\n  .ih-stage {\n    height: 400px;\n    order: -1;\n  }\n}\n\n@media (max-width: 640px) {\n  .ih-stage {\n    height: 300px;\n  }\n  .ih-hud--bl {\n    display: none;\n  }\n  .ih-facts {\n    grid-template-columns: repeat(2, max-content);\n    gap: 16px 28px;\n  }\n}\n\n/* ── 공정 ──────────────────────────────────────────── */\n.ip-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.35fr) minmax(300px, 0.75fr);\n  gap: 24px;\n  align-items: stretch;\n}\n\n.ip-stage {\n  min-height: 440px;\n  background:\n    radial-gradient(ellipse 60% 40% at 50% 70%, rgba(12, 17, 24, 0.08), transparent 70%),\n    var(--sunk);\n}\n\n.ip-stage .iso3d {\n  position: absolute;\n  inset: 0;\n}\n\n.ip-fallback {\n  width: 70%;\n  height: 70%;\n}\n\n.ip-cap {\n  position: absolute;\n  left: 18px;\n  bottom: 16px;\n  font-size: 11px;\n  letter-spacing: 0.06em;\n  color: var(--ink-3);\n  background: rgba(255, 255, 255, 0.78);\n  border: 1px solid var(--line);\n  border-radius: 6px;\n  padding: 8px 12px;\n  backdrop-filter: blur(6px);\n  pointer-events: none;\n  line-height: 1.6;\n  text-transform: uppercase;\n  max-width: calc(100% - 36px);\n}\n\n.ip-cap b {\n  color: var(--ink);\n  font-weight: 600;\n}\n\n.ip-cap-meta {\n  display: block;\n  color: var(--brand);\n}\n\n.ip-auto {\n  position: absolute;\n  right: 14px;\n  top: 14px;\n  height: 28px;\n  padding: 0 10px;\n  border-radius: var(--r-pill);\n  background: rgba(255, 255, 255, 0.8);\n  border: 1px solid var(--line);\n  font-family: var(--f-m);\n  font-size: 10.5px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--ink-3);\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  backdrop-filter: blur(6px);\n}\n\n.ip-auto.is-on {\n  color: var(--brand);\n  border-color: var(--brand-soft-2);\n}\n\n.ip-steps {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0;\n}\n\n.ip-step {\n  width: 100%;\n  text-align: left;\n  display: grid;\n  grid-template-columns: 34px 1fr;\n  gap: 12px;\n  padding: 16px 18px 16px 16px;\n  border-radius: var(--r-2);\n  border: 1px solid var(--line);\n  background: var(--surface);\n  position: relative;\n  overflow: hidden;\n  transition: all var(--dur) var(--ease);\n  color: inherit;\n}\n\n.ip-step:hover {\n  border-color: var(--line-strong);\n  transform: translateX(3px);\n}\n\n.ip-step.is-on {\n  border-color: var(--brand);\n  box-shadow: var(--sh-iso-brand);\n  transform: translate(-2px, -2px);\n}\n\n.ip-step-n {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.1em;\n  color: var(--ink-3);\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  background: var(--surface-3);\n  display: grid;\n  place-items: center;\n  transition: all var(--dur);\n  flex: none;\n}\n\n.ip-step.is-on .ip-step-n,\n.ip-step-n.is-on {\n  background: var(--brand);\n  color: #fff;\n}\n\n.ip-step.is-done .ip-step-n {\n  background: var(--ok-soft);\n  color: var(--ok);\n}\n\n.ip-step-body {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.ip-step-t {\n  font-family: var(--f-d);\n  font-size: 16.5px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--ink);\n}\n\n.ip-step-d {\n  font-size: 13px;\n  color: var(--ink-3);\n  line-height: 1.55;\n  margin-top: 3px;\n  display: none;\n}\n\n.ip-step.is-on .ip-step-d {\n  display: block;\n}\n\n.ip-step-meta {\n  font-size: 10.5px;\n  letter-spacing: 0.06em;\n  color: var(--brand);\n  margin-top: 8px;\n  display: none;\n}\n\n.ip-step.is-on .ip-step-meta {\n  display: block;\n}\n\n.ip-step-bar {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  height: 3px;\n  width: 100%;\n  background: var(--brand);\n  transform-origin: left;\n  animation: ipbar linear both;\n}\n\n@keyframes ipbar {\n  from { transform: scaleX(0); }\n  to { transform: scaleX(1); }\n}\n\n/* 모바일 전용 설명 카드 — 데스크톱에서는 숨긴다 */\n.ip-detail {\n  display: none;\n  background: var(--surface);\n  border: 1px solid var(--line);\n  border-radius: var(--r-2);\n  padding: 16px 18px;\n}\n\n.ip-detail-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.ip-detail-head b {\n  font-family: var(--f-d);\n  font-size: 17px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.ip-detail p {\n  color: var(--ink-2);\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.ip-detail .btn-link {\n  margin-top: 10px;\n}\n\n/* ── 태블릿 이하: 무대 → 4칸 스트립 → 설명 카드 ── */\n@media (max-width: 960px) {\n  .ip-grid {\n    grid-template-columns: 1fr;\n    gap: 14px;\n  }\n  .ip-stage {\n    min-height: 380px;\n  }\n  .ip-steps {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 8px;\n  }\n  .ip-step {\n    grid-template-columns: 1fr;\n    gap: 8px;\n    padding: 12px 8px 14px;\n    text-align: center;\n    justify-items: center;\n    align-content: start;\n    min-height: 100%;\n  }\n  .ip-step:hover {\n    transform: none;\n  }\n  .ip-step.is-on {\n    transform: none;\n    box-shadow: 4px 4px 0 var(--brand-deep);\n    background: var(--brand-soft);\n  }\n  .ip-step-n {\n    width: 30px;\n    height: 30px;\n    font-size: 11px;\n  }\n  .ip-step-body {\n    align-items: center;\n  }\n  .ip-step-t {\n    font-size: 13px;\n    line-height: 1.25;\n  }\n  .ip-step.is-on .ip-step-d,\n  .ip-step.is-on .ip-step-meta {\n    display: none;\n  }\n  .ip-detail {\n    display: block;\n  }\n}\n\n@media (max-width: 640px) {\n  .ip-stage {\n    min-height: 300px;\n  }\n  .ip-cap {\n    left: 10px;\n    bottom: 10px;\n    padding: 6px 9px;\n    font-size: 10px;\n  }\n  .ip-auto {\n    right: 10px;\n    top: 10px;\n  }\n  .ip-step {\n    padding: 10px 4px 12px;\n  }\n  .ip-step-t {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
